import { Route, Routes } from "react-router-dom";
import THContent from "./function-components/THContent";
import DLRequestor from "./function-components/Requestor/DLRequestor";
import DLNavbar from "./function-components/DLNavbar";
import { useSelector } from "react-redux";
import PrivateRoute from "../../ProtectedRoute";
import LoadingSpinner from "../../utils/loadingSpinner";


const DeliveryLeadershipPages = () => {

  const { loggedInUserRoles: userRoles, rolesLoading } = useSelector(
    (state) => state.deliveryLeadership
  );

  if (rolesLoading) {
    return <LoadingSpinner text="Checking access..." />;
  }

  return (
    <>
      <DLNavbar userRoles={userRoles}/>
      <Routes>
        <Route index element={<DLRequestor/>} />  
        <Route path="/requestor" element={<DLRequestor/>} />
        <Route
            path="/TH"
            element={
              <PrivateRoute
               trackId={1}
               allowedRoles={["th"]}
              >
                <THContent />
              </PrivateRoute>
            }
          />
      </Routes>
    </>
  );
};

export default DeliveryLeadershipPages;
